import Dropdown from '@jetbrains/ring-ui/components/dropdown/dropdown'
import plur from 'plur'

import {stringifyId} from '../../../../../types'
import Link from '../../../../common/Link/Link'
import MiddleEllipsis from '../../../../common/MiddleEllipsis/MiddleEllipsis'
import Popup from '../../../../common/Popup/Popup.lazy'
import type {PolicyTemplates, PolicyTemplate} from '../../CleanupProjectPage.types'
import {getHolderTemplateLink} from '../HolderItem.utils'

import styles from './TemplateSection.css'

type TemplateSectionProps = {
  templates: PolicyTemplates
}
const popupTitle = `This build configuration is based on the following templates:`

type TemplateLinkProps = {
  template: PolicyTemplate
}
function TemplateLink({template}: TemplateLinkProps) {
  return (
    <Link href={getHolderTemplateLink(template.externalId)}>
      <MiddleEllipsis tailLength={15}>{template.fullName}</MiddleEllipsis>
    </Link>
  )
}

function TemplateCollapsibleSection({templates}: TemplateSectionProps) {
  return (
    <Dropdown anchor={`${templates.length} ${plur('template', templates.length)}`}>
      <Popup className={styles.popup}>
        <p className={styles.description}>{popupTitle}</p>
        {templates.map(template => (
          <div key={stringifyId(template.externalId)}>
            <TemplateLink template={template} />
          </div>
        ))}
      </Popup>
    </Dropdown>
  )
}

function TemplateSection({templates}: TemplateSectionProps) {
  if (!templates.length) {
    return null
  }

  return (
    <div className={styles.templateList}>
      <span className={styles.title}>{'Based on: '}</span>
      <div className={styles.templateEntities}>
        {templates.length === 1 ? (
          <TemplateLink template={templates[0]} />
        ) : (
          <TemplateCollapsibleSection templates={templates} />
        )}
      </div>
    </div>
  )
}

export default TemplateSection
